import DatePickerCalendar from "../../dashboard/calendars/DatePickerCalendar";
import ReactTooltip from "react-tooltip";
import Constants from "../../../Constants";
import Select from "react-select";
import { dateConvertToTimeStamp, dateFormat, dateFormatAccToTimeZone, timeStamp, TIME_LIST, transformBlankToNull, utcDateTimeWithTimeZone, utcDateTimeWithTimeZoneWithFormat } from "../../../services/Util";
import React, { useEffect, useRef, useState } from "react";
import APIUrls from "../../../services/APIUrls";
import $ from "jquery";
import { getAxiosResponse, putAxiosResponse } from "../../../services/authApiRoutes/APImethods";
import { calenderIcon, FollowerTooltipIcon } from "../../../AppIcons";

export default function RequestTranslationAgain(prop) {
    const [toggleIntialCal, toggleIntialCalFlag] = useState(false);
    const [customerBootstrapData, setCustomerBootstrapData] = useState(false);
    const [deliveryDueDate, setDeliveryDueDate] = useState("");
    const [deliveryDueTime, setDeliveryDueTime] = useState(-1);
    const [showMatchedInternalTranslators, setShowMatchedInternalTranslators] = useState(false);
    const [showOtherInternalTranslators, setShowOtherInternalTranslators] = useState(false);
    const [allInternalTranslators, setAllInternalTranslators] = useState([]);
    const [matchedInternalTranslators, setMatchedInternalTranslators] = useState([]);
    const [otherInternalTranslators, setOtherInternalTranslators] = useState([]);
    const [selectedInternalTranslator, setSelectedInternalTranslator] = useState({});
    const [internalTranslationRequest, setInternalTranslationRequest] = useState([]);

    const refToggle2 = useRef(null);
    const refCalendar2 = useRef(null);

    const projectResource = prop?.projectDetails?.resource?.projectResource;
    const displayNameData = prop?.projectDetails?.displayName[0];

    const getInternalTranslatorVendor = async (depId) => {
		const dateTimestamp = dateConvertToTimeStamp();
		const result = await getAxiosResponse(APIUrls.INTERNAL_TRANSALATOR(depId) + `?_=${dateTimestamp}`)
		if(result?.data?.data) {
            let translatorsWithLanguagePairs = result.data.data.filter((translator) => translator?.languagePairs?.length > 1)
            let matchedIntTranslators = [];
            let otherTranslators = [];
            translatorsWithLanguagePairs.map((t) => {
                t.languagePairs.map((lp) => {
                if(lp.source ===  displayNameData?.sourceLanguage?.language && 
                    projectResource.targetLanguages.includes(lp.target)) {
                    matchedIntTranslators.push(t);
                } 
                if(lp.source === displayNameData?.sourceLanguage?.parentLanguage?.display) {
                    displayNameData?.targetLanguages?.map((targetLang) => {
                    if(targetLang?.parentLanguage?.display === lp.target) {
                        matchedIntTranslators.push(t);
                    }
                    })
                }
                })
            })
            
            if(matchedIntTranslators.length > 0) {
                setShowMatchedInternalTranslators(true);
                result.data.data.map((translator) => {
                matchedIntTranslators?.map((match) => {
                    if(match.userId !== translator.userId) {
                    otherTranslators.push(translator);
                    }
                })
            })} else {
                setShowOtherInternalTranslators(true);
                otherTranslators = result.data.data;
            }
            setMatchedInternalTranslators(matchedIntTranslators);
            setOtherInternalTranslators(otherTranslators);
            setAllInternalTranslators(result.data.data);
		}
	}

    useEffect(() => {
        getAxiosResponse(APIUrls.CUSTOMER_BOOTSTRAP_DATA)
        .then((res) => {
            setCustomerBootstrapData(res.data.data);
        })

        getAxiosResponse(APIUrls.INTERNAL_REQUEST(projectResource?.id)).then((res) => {
            if (res.data !== "") {
                setInternalTranslationRequest(res.data.data);
                setSelectedInternalTranslator(res.data.data.assigneeUser);
            }
        });
    },[]);

    useEffect(() => {
        getInternalTranslatorVendor(projectResource?.userGroup?.id);
    }, [projectResource])

    const hideModel = () => {
        document.body.classList.remove("modal-open-7");
        prop.closePopup()
    }
    $(document).on("click",".requestBtn",function() {
      $(this).addClass('focusAdd');
      $(".set-right").trigger("focus");
     
      $("#submitBidsTooltip").on("keydown", function (e) {
        if (e.key === Constants.TAB && e.shiftKey) {
          e.preventDefault();
          $('.setSave').trigger('focus');
      }
      });
     // !($('#submitBidsTooltip').attr('aria-describedby'))
      $(".inner-lightbox-panel").on("keydown", function (e) {
        let allAreFalse = true;
        $('.small-dropdown-select').each(function() {
          if ($(this).find('input').attr('aria-expanded') !== 'false') {
            allAreFalse = false;
            return false;
          }
        });
       
        if (e.key === Constants.ESCAPE  && allAreFalse && !($('.dashCalendarDeadLine').length) && !($('#submitBidsTooltip').is('[aria-describedby]'))) {
          hideModel()
          $('.focusAdd').trigger('focus');
          $('.requestBtn').removeClass('focusAdd');
        }
      });
    });
    const setSaveKeydown = (event) => {
      if (event.key === Constants.TAB && !event.shiftKey) {
          event.preventDefault();
          $("#submitBidsTooltip").trigger("focus");
      }
    };
    $(document).on("click",".modal-footer .set-right",function() {
     $('.focusAdd').trigger('focus');
     $('.requestBtn').removeClass('focusAdd');
   });
  
    const showCalendarDeliveryDate = () => {
        toggleIntialCal ? toggleIntialCalFlag(false) : toggleIntialCalFlag(true);
        $('#calFirstFocus').toggleClass('calFirstFocus')
        $('.calFirstFocus').trigger('focus')
        $(document).mouseup(function(e) {
          var bannerCont = $('.firstCal');
          if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
              toggleIntialCalFlag(false)
              $('#calFirstFocus').removeClass('calFirstFocus')
        }
        });
    };
    $("#calFirstFocus").on("keydown", function (e) {
      if (e.key === Constants.ESCAPE) {
        if($('div').hasClass('dashCalendarDeadLine')){
          setTimeout(() => {
            toggleIntialCalFlag(false)
            $('.calFirstFocus').trigger('focus')
            $('#calFirstFocus').removeClass('calFirstFocus')
          }, 100);
         }
       }
       if (e.key === Constants.TAB && e.shiftKey) {
        if($('div').hasClass('dashCalendarDeadLine')){
          toggleIntialCalFlag(false)
          $('.calFirstFocus').trigger('focus')
          $('#calFirstFocus').removeClass('calFirstFocus')
         }
       }
      });
      
     const handleDropdownEscFocus = (event) => {
      if (event.key === Constants.ESCAPE) {
         setTimeout(() => {
          toggleIntialCalFlag(false)
          $('.calFirstFocus').trigger('focus')
          $('#calFirstFocus').removeClass('calFirstFocus')
         }, 100);
      }
    }
    const closeCalendar = (e) => {
      if (e.code === "Escape") {
        setTimeout(() => {
          toggleIntialCalFlag(false);
        $('.calFirstFocus').trigger('focus')
        $('#calFirstFocus').removeClass('calFirstFocus')
        }, 100);
      }
    };

    const setDeliveryDate = (event) => {
      let updatedTime = deliveryDueTime !== -1 ? deliveryDueTime : parseInt(dateFormatAccToTimeZone(projectResource?.deliveryDueDate?.utcTimestamp, "H" , customerBootstrapData?.user?.timeZone));
      let updatedDateWithTime = new Date(event).setHours(updatedTime);
      setDeliveryDueDate(updatedDateWithTime);
      toggleIntialCalFlag(false);
      $('.calFirstFocus').trigger('focus')
      $('#calFirstFocus').removeClass('calFirstFocus')
    };
    useEffect(()=>{
      $.each($('.react-calendar__tile'), function( index, value ) {
        $(value).attr('aria-label', value.children[0].ariaLabel);
      });
    });
    const setTime = (event) => {
        let currentDeliveryDueDate = deliveryDueDate !== "" ? new Date(deliveryDueDate) : new Date(projectResource?.deliveryDueDate?.utcTimestamp);
        currentDeliveryDueDate.setHours(event.value);
        setDeliveryDueDate(currentDeliveryDueDate);
        setDeliveryDueTime(event.value);
    };

    const assigneeUser = (data) => {
		allInternalTranslators.forEach((obj) => {
			if (data.userId === obj.userId) {
				obj.checked ? obj.checked = false  : obj.checked = true;
                if(obj.checked) {
                setSelectedInternalTranslator({userId: data.userId, firstName: data.firstName, lastName: data.lastName})
                } else {
                setSelectedInternalTranslator({userId: -1})
                }
			}
			else {
				obj.checked = false;
			}
            return obj;
		})
	}
  const assigneeUserOnKeyDown = (event, data) => {
		if(event.key === Constants.ENTER || event.keyCode === 32) {
			assigneeUser(data);
		}
	}

    const saveNewTranslationRequest = () => {
        let newAssignmentPayload = Object.assign({}, internalTranslationRequest);
        newAssignmentPayload.assigneeUser = selectedInternalTranslator;
    
        let newProjectResource = Object.assign({}, projectResource);
        newProjectResource.assignment = newAssignmentPayload;
        if(deliveryDueDate !== '') {
          newProjectResource.deliveryDueDate = timeStamp(deliveryDueDate, customerBootstrapData.user?.timeZone);
          newProjectResource.deliveryDueDateChanged = true;
          newProjectResource.deliveryDueDateEditable = true;
        }
        newProjectResource.status = "WAITING_FOR_INTERNAL_TRANSLATOR_ACCEPTANCE";
        var payload = transformBlankToNull(newProjectResource);
        putAxiosResponse(APIUrls.PROJECT(projectResource?.id), payload).then((res) => {
          hideModel();
          prop.refresh();
        });
    }
    const [refs, setRefs] = useState({});
    const submitBidsTooltipRef = useRef(null);
    $('.tooltip-container p').on('keydown', function(e){
      if(e.key === Constants.ESCAPE){
        if ($(this).attr('id') === "submitBidsTooltip") {
          setRefs(submitBidsTooltipRef);
        }
      }
    });
    useEffect(()=>{
     if (refs.current) {
        refs.current.hideTooltip();
        setRefs({});
      }
    }, [refs]);
    return <div id="modal-open-7" className="lightbox-panel" aria-labelledby="requestTranslationAgain" aria-modal="true" role="dialog">
    <div className="inner-lightbox-panel pb-0">
      <div className="modal-header flex padd-lr">
        <strong id="requestTranslationAgain">Request Translation Again</strong>
      </div>
      <div className="lightbox-content padd-22 vender-form-block">
        <p>
          The internal translator has rejected your request. You can choose to request translation again from the same or a different internal translator.
        </p>
        <div className="flex wrap-dropdown wrap-group-dropdown" tabIndex="0" >
            <div className="global-dropdown-block flex-center">
              <div className="tooltip-container">
                <strong>I need initial translation by</strong>
                <p tabIndex={0} data-events={['focus']} data-eventsoff={['blur']} data-padding="10px 10px 10px 10px"
                  data-place="right" data-tip={Constants.TRANSLATION_SUBMISSION_TOOLTIP} data-for="bid-submission-tooltip"
                  aria-label="Tooltip" id="submitBidsTooltip" >
                  {FollowerTooltipIcon}
                  <span className="font-zero">{Constants.TRANSLATION_SUBMISSION_TOOLTIP}</span>
                </p>
                <ReactTooltip className="tooltip" id="bid-submission-tooltip" role="tooltip" ref={submitBidsTooltipRef} ></ReactTooltip>
              </div>
              <div className="flex-center w-d100 firstCal">
                <div className="global-dropdown-select" aria-label="I need initial translation by" >
                  <button onClick={(e) => { showCalendarDeliveryDate(e); }} onKeyDown={(e) => handleDropdownEscFocus(e)}
                    id='calFirstFocus' aria-expanded={toggleIntialCal ? 'true':'false'} ref={refToggle2} tabIndex={0} type="button" className="drop-down-btn gb-dropBtn">
                    <span> {deliveryDueDate !== "" ? dateFormat(deliveryDueDate, Constants.DATE_IN_WORDS) : projectResource?.deliveryDueDate
                        ? dateFormatAccToTimeZone(projectResource?.deliveryDueDate?.utcTimestamp, Constants.DATE_IN_WORDS, customerBootstrapData?.user?.timeZone)
                        : "Day, Month, Year"
                    }
                    </span>
                    {calenderIcon}
                  </button>
                </div>
                {toggleIntialCal ? (
                  <div ref={refCalendar2} onKeyDown={(e) => { closeCalendar(e); }} >
                    <DatePickerCalendar value={ deliveryDueDate !== "" ? new Date(deliveryDueDate) : new Date(projectResource?.deliveryDueDate?.utcTimestamp)}
                        minDate={ new Date() } className="dashCalendarDeadLine" selectDate={setDeliveryDate}
                    />
                  </div>
                 ) : ( "" )} 
                <div className="global-dropdown-select small-dropdown-select">
                  <Select classNamePrefix="cw"
                    value={TIME_LIST.filter(function (option) {
                      return (
                        option?.value == (deliveryDueTime === -1 ? dateFormatAccToTimeZone(projectResource?.deliveryDueDate?.utcTimestamp, "H", customerBootstrapData?.user?.timeZone)
                          : deliveryDueTime)
                      );
                    })}
                    onChange={(event) => setTime(event)} options={TIME_LIST} menuShouldScrollIntoView={false} aria-label="what time"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="mar-bot6" id="selectTranslator">
            <strong>Select your internal translator </strong> (click on a translator to select or deselect)
          </div>
          <div className="mar-bot6">
            <strong>Project Languages</strong>
          </div>
          <div className="mar-bot6">
            <p>
              {displayNameData.sourceLanguage?.display + " to "}
              {displayNameData.targetLanguages.map(lang => lang.display).join(", ")}
            </p>
          </div>
          {showMatchedInternalTranslators && 
            <div className="mar-bot6">
                <strong>Matched Internal Translators</strong>
            </div>
          } 
          {showMatchedInternalTranslators && 
          <div>
            <div className="translate-box flex">
                {matchedInternalTranslators && matchedInternalTranslators.length > 0 &&
                  matchedInternalTranslators.map((res, index) => (
                    <div key={index} className="translate-box-list">
                      <a tabIndex="0" onClick={() => assigneeUser(res)} className={res.checked === true || selectedInternalTranslator.userId === res.userId? ' vendor' : ''} aria-label="tab">
                        <span>{res.firstName} {res.lastName}</span>
                      </a>
                    </div>
                  ))
                }
              </div>
          </div>
          }
          {showOtherInternalTranslators && <div>
            <div className="translate-box flex" role="radiogroup" aria-labelledby="selectTranslator">
                {otherInternalTranslators && otherInternalTranslators.length > 0 &&
                  otherInternalTranslators.map((res, index) => (
                    <div key={index} className="translate-box-list" role='none'>
                      <a tabIndex="0" onClick={() => assigneeUser(res)} onKeyDown={(e) => assigneeUserOnKeyDown(e,res)}
                       role="radio" aria-checked={res.checked === true || selectedInternalTranslator.userId === res.userId? 'true' : 'false'}
                      className={res.checked === true || selectedInternalTranslator.userId === res.userId? ' vendor' : ''}>
                        <span>{res.firstName} {res.lastName}</span>
                      </a>
                    </div>
                  ))
                }
              </div>
          </div>}
      </div>
      <div className="modal-footer modal-footer-border flex px-22">
        <button className="btn btn-bold set-right" onClick={hideModel}>
          Cancel
        </button>
        <button className="btn btn-bold active setSave" onClick={saveNewTranslationRequest} onKeyDown={setSaveKeydown}>
          OK
        </button>
      </div>
    </div>
    </div>
}